module.exports = __webpack_public_path__ + "static/media/Example.ec14962a.svg";